'use client';

import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { Typography } from 'lighthouse';

import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { copyToClipboard } from '@/utilities/copyToClipboard';
import { getStrapiImageUrl } from '@/utilities/strapiImageUrl';

import { BannerDetailModalProps } from './models';

import { cornbar } from 'cornbar';

export const BannerDetailModal = ({ onClose, contentData }: BannerDetailModalProps) => {
    const router = useRouter();

    const handleOnClickLink = async () => {
        switch (contentData.linkTarget) {
            case 'NEW_TAB':
                window.open(contentData.modalButtonLink || '', '_blank');
                break;
            case 'COPY':
                await copyToClipboard(contentData.modalButtonLink || '');
                cornbar.show({
                    title: 'عملیات موفق بود',
                    description: `${contentData.modalButtonLink} کپی شد!`,
                    variant: 'success'
                });
                break;
            default:
                void router.push(contentData.modalButtonLink || '', {});
                break;
        }
    };

    return (
        <SwipeableDrawer
            open
            onClose={onClose}
            title={contentData.modalTitle}
            primaryActionText={contentData.modalButtonTitle}
            primaryActionProps={{ onClick: handleOnClickLink }}>
            <div className='w-full px-8 pb-2'>
                <Typography color='N800' variant='body1' fontWeight={800} textAlign='center'>
                    {contentData.modalPrimaryTitle}
                </Typography>
                {!!contentData.modalImage && (
                    <div className='flex items-center justify-center'>
                        <Image
                            className=''
                            src={getStrapiImageUrl(contentData.modalImage.url)}
                            width={180}
                            height={180}
                            alt={contentData.modalTitle}
                        />
                    </div>
                )}
                <Typography color='N700' variant='body1' fontWeight={400} className='mt-4 whitespace-pre'>
                    {contentData.modalDescription}
                </Typography>
            </div>
        </SwipeableDrawer>
    );
};
